<!-- Main Page Start -->
<div class="content-wrapper table-full-bx">
  <div class="page-content graphs">
    <div class="ibox">
      <div class="ibox-body">
        <div class="flexbox mb-3">
          <div class="iboxcontent">
            <h3>Job performance report</h3>
          </div>
          <div class="input-group-icon input-group-icon-left">
            <div class="commonBtn2 filter" (click)="openModal(Filter)">
              <div class="redDot" *ngIf="show == 1"></div>
              <img src="../../../../../../../assets/images/filter-filled-tool-symbol-svgrepo-com.svg">
            </div>

          </div>
        </div>
        <!-- stats -->
        <div class="row">

          <div class="col-md-6 col-lg-3">
            <div class="card mb-4">
              <div class="card-body flexbox-b">
                <div>
                  <div class="text-muted">Impressions</div>
                  <h3 class="font-strong"> {{allData?.impressions}}</h3>
                  <small class="green profitLoss" *ngIf="allData?.impressions > 0"><img
                      src="../../../assets/images/ic_up.svg" /> 
                      {{ ( (allData?.currentMonthImpressions - allData?.lastMonthImpressions)/(allData?.currentMonthImpressions + allData?.lastMonthImpressions) | number : '1.2-2') ||
                    "0"}} % more</small>
                  <small class="red profitLoss" *ngIf="allData?.impressions < 0"><img
                      src="../../../assets/images/ic_loss.svg" /> {{(allData?.lastMonthImpressions -
                    allData?.currentMonthImpressions)/(allData?.currentMonthImpressions + allData?.lastMonthImpressions)
                    || "0"}} % less</small>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-lg-3">
            <div class="card mb-4">
              <div class="card-body flexbox-b">
                <div>
                  <div class="text-muted">Clicks</div>
                  <h3 class="font-strong"> {{allData?.clicks}}</h3>
                  <small class="green profitLoss" *ngIf="allData?.clicks > 0"><img
                      src="../../../assets/images/ic_up.svg" /> {{allData?.clicks + "%"}} more</small>
                  <small class="red profitLoss" *ngIf="allData?.clicks < 0"><img
                      src="../../../assets/images/ic_loss.svg" /> {{allData?.clicks + "%"}} less</small>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-3">
            <div class="card mb-4">
              <div class="card-body flexbox-b">
                <div>
                  <div class="text-muted">Apply start rate</div>
                  <h3 class="font-strong"> {{allData?.clicks != 0 ? ((allData?.applyStarts/allData?.clicks)* 100 | number : '.2-2') : 0}}</h3>
                  <small class="green profitLoss" *ngIf="allData?.applyStartRate > 0"><img
                      src="../../../assets/images/ic_up.svg" /> {{allData?.applyStartRate + "%"}} more</small>
                  <small class="red profitLoss" *ngIf="allData?.applyStartRate < 0"><img
                      src="../../../assets/images/ic_loss.svg" /> {{allData?.applyStartRate + "%"}} less</small>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-3">
            <div class="card mb-4">
              <div class="card-body flexbox-b">
                <div>
                  <div class="text-muted">Apply starts</div>
                  <h3 class="font-strong"> {{allData?.applyStarts}}</h3>
                  <small class="green profitLoss" *ngIf="allData?.applyStarts > 0"><img
                      src="../../../assets/images/ic_up.svg" /> {{allData?.applyStarts + "%"}} more</small>
                  <small class="red profitLoss" *ngIf="allData?.applyStarts < 0"><img
                      src="../../../assets/images/ic_loss.svg" /> {{allData?.applyStarts + "%"}} less</small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <!-- 1 -->
          <div class="col-md-7 col-lg-8">
            <div class="ibox inventory-chart">
              <div class="ibox-head">
                <div class="ibox-title">Top 6 jobs by impressions</div>
              </div>
              <div class="ibox-body">
                <div>
                  <div id="bar-Horizontal" class="chartBar"></div>
                </div>
                <div *ngIf="noDataFound" class="chartBar noDataFound">
                  <h2> No Data Found</h2>
                </div>
              </div>
            </div>
          </div>

          <!-- 2 -->
          <div class="col-md-5 col-lg-4">
            <div class="ibox pieChart inventory-chart">
              <div class="ibox-head">
                <div class="ibox-title">Desktop vs mobile clicks</div>
              </div>
              <div class="ibox-body">
                <div>
                  <div class="charthead">
                    <h6>Total Visitors </h6>
                    <h5>{{allData?.totalVisitors}}</h5>
                  </div>
                  <div>
                    <div id="pie" class="chartPie"></div>
                  </div>
                  <ul class="chartDetail">
                    <li class="charthead">
                      <h6>Desktop Clicks</h6>
                      <h5>{{allData?.desktopClicks}}</h5>
                      <small class="green profitLoss" *ngIf="allData?.desktopClicks > 0"><img
                          src="../../../assets/images/ic_up.svg" /> {{(allData?.desktopClicks) + "%"}} more</small>
                      <small class="red profitLoss" *ngIf="allData?.desktopClicks < 0"><img
                          src="../../../assets/images/ic_loss.svg" /> {{allData?.desktopClicks + "%"}} less</small>
                    </li>
                    <li class="charthead">
                      <h6>Mobile Clicks</h6>
                      <h5>{{allData?.mobileClicks}}</h5>
                      <small class="green profitLoss" *ngIf="allData?.mobileClicks > 0"><img
                          src="../../../assets/images/ic_up.svg" /> {{allData?.mobileClicks + "%"}} more</small>
                      <small class="red profitLoss" *ngIf="allData?.mobileClicks < 0"><img
                          src="../../../assets/images/ic_loss.svg" /> {{allData?.mobileClicks + "%"}} less</small>
                    </li>
                  </ul>
                </div>
                <div *ngIf="noDataFound" class="chartBar noDataFound">
                  <h2> No Data Found</h2>
                </div>
              </div>
            </div>
          </div>
          <!-- 1 -->
          <div class="col-md-12">
            <div class="ibox nventory-chart">
              <div class="ibox-head">
                <div class="ibox-title mb-2">Job performance report<br><small>{{totalCount?.jobsCount}} Jobs |
                    {{totalCount?.jobsLocationCount}} Locations</small></div>
                <a href="javascript:void(0);" class="downloadBtn" (click)="downloadCsv()">Download Report</a>
              </div>
              <div class="ibox-body jobPerformanceTable" style="padding-top:0;">
                <!-- Table -->
                <div class="table-scroll table-wrapper user-top table-responsive">
                  <table id="example" class="table table-bordered table-hover m-0  " style="width: 100%;">
                    <thead>
                      <tr>
                        <th>Status</th>
                        <th>Job title</th>
                        <th>Location</th>
                        <th>Job ID</th>
                        <th>Last updated date</th>
                        <th>Impressions</th>
                        <th>Clicks</th>
                        <th>Apply starts</th>
                        <th>CTR</th>
                        <th>Apply start rate</th>
                        <th>Apply completion rate</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="let data of tableData | paginate: { id:'pagination', itemsPerPage: pagination.limit, currentPage: currentPage ,totalItems: pagination.totalItems};let i=index">
                        <td><a>
                            <span class="green" *ngIf="data?.isBlocked == 0 && data?.isConfirm == 1">Open</span>
                            <span class="red" *ngIf="data?.isBlocked == 1  && data?.isConfirm == 1">Closed</span>
                            <span class="red" *ngIf="data?.isConfirm == 0">Draft</span>
                          </a></td>
                        <td><a>{{data?.jobTitle || "-"}} </a></td>
                        <td><a>{{data?.workPlaceLocation == "Remote" ? "Remote": data?.location}}</a></td>
                        <td><a>{{data?.id}}</a></td>
                        <td><a>{{data?.updatedAt | date: "d/M/YYYY"}}</a></td>
                        <td><a>{{data?.impressions || "0"}}</a></td>
                        <td><a>{{data?.total || "0"}}</a></td>
                        <td><a>{{data?.applyStart || "0"}}</a></td>
                        <td><a>{{data?.ctr || "0"}}</a></td>
                        <td><a>{{data?.applyStartRate || "0"}}</a></td>
                        <td><a>{{data?.applyComplition || "0"}}</a></td>
                      </tr>

                    </tbody>
                  </table>
                  <div class="noDataFound" *ngIf="tableData == 0">
                    <h2>No Records Found</h2>
                  </div>

                </div>
                <!-- end -->
                <!--  pagination  -->
                <div class="col-sm-12 p-0" *ngIf="tableData.length > 0">
                  <ul class="pagination ">
                    <pagination-controls id="pagination" (pageChange)="pageChanged($event)" previousText="&#60;"
                      nextText="Next" firstText="&#62;" lastText="Last"></pagination-controls>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Filter -->
<ng-template #Filter let-modal>
  <div class="modal-body">
    <h4 class="pageTitle upper">Filter</h4>
    <form [formGroup]="filterForm">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>From Date<i class="text-danger">*</i></label>
            <input formControlName="startDate" type="text" placeholder="Select From Date" class="form-control"
              bsDatepicker [bsConfig]="{
                  isAnimated: true,
                  dateInputFormat: 'DD-MM-YYYY',
                  showWeekNumbers: false
                }" [maxDate]="today" />
            <div class="text-danger" *ngIf="
                  filterForm.controls['startDate'].hasError('required') &&
                  showError
                ">
              *Please enter valid date.
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label>To Date<i class="text-danger">*</i></label>
            <input formControlName="endDate" type="text" placeholder="Select To Date" class="form-control" bsDatepicker
              [bsConfig]="{
                  isAnimated: true,
                  dateInputFormat: 'DD-MM-YYYY',
                  showWeekNumbers: false
                }" [maxDate]="today" />
            <div class="text-danger" *ngIf="
                  filterForm.controls['endDate'].hasError('required') && showError
                ">
              *Please enter valid date.
            </div>
            <div class="text-danger" *ngIf="invalidDateFilter">
              *End Date should always be greater than Start Date.
            </div>
          </div>
        </div>
      </div>

      <div class="form-group text-right">
        <a href="javascript:void(0);" class="planbtn greyBtn" (click)="clearFilter(modal);modalRef?.hide()">Clear</a>
        <input type="submit" value="Apply" class="planbtn fill" (click)="applyFilter(modal)">
      </div>
    </form>
  </div>
</ng-template>